import axios, { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios'
import { firebase } from 'firebaseApp'

export interface CustomAxiosError {
  errorCode: number | undefined
  errorMessage: string | undefined
  errorMoreInfo: any
}

class CustomError extends Error implements CustomAxiosError {
  errorCode: number | undefined
  errorMessage: string | undefined
  errorMoreInfo: any

  constructor(errorCode: number | undefined, errorMessage: string | undefined, errorMoreInfo: any) {
    super(typeof errorMoreInfo === 'string' ? errorMoreInfo : errorMessage)

    this.errorCode = errorCode
    this.errorMessage = errorMessage
    this.errorMoreInfo = errorMoreInfo

    Object.setPrototypeOf(this, CustomError.prototype)
  }
}

export async function callAxios<T = any>(config: AxiosRequestConfig): Promise<T> {
  try {
    const response: AxiosResponse<T> = await axios({
      ...config,
      headers: {
        Authorization: `Bearer ${await firebase.auth().currentUser?.getIdToken()}`,
      },
    })

    return response.data
  } catch (error: any) {
    const errorResponse = (error as AxiosError)?.response
    const { response: errorResponseData, statusCode } = errorResponse?.data || {}

    const errorCode = errorResponseData?.errorCode ?? statusCode ?? errorResponse?.status
    const errorMoreInfo = errorResponseData?.errorMoreInfo
    const errorMessage =
      typeof errorMoreInfo === 'string' ? errorMoreInfo : errorResponseData?.errorMessage ?? errorResponseData?.message

    throw new CustomError(errorCode, errorMessage, errorMoreInfo)
  }
}
